import React, { useState, useContext, useCallback } from 'react';
import type { EHR } from 'vim-os-js-browser/types';
import { DetailsCardItem } from '@getvim/atomic-ui';
import SelectIcdToWriteback from '../common/SelectIcdToWriteback';
import EditableInput from '../common/editable-text-area-input/EditableTextAreaInput';
import { useVimWritebackWrapper } from '../../hooks/useVimWritebackWrapper';
import { VimOSContext } from '../../vimOsContext';

const EncounterAssessment = ({ encounter }: { encounter: EHR.Encounter | undefined }) => {
  const [generalNotes, setGeneralNotes] = useState<string>('');
  const writeback = useVimWritebackWrapper();
  const { ehr } = useContext(VimOSContext);
  const { resourceUpdater } = ehr;

  const onSubmitGeneralNotes = useCallback(
    async (generalNotes: string) => {
      setGeneralNotes(generalNotes);
      return writeback(resourceUpdater.updateEncounter({ assessment: { generalNotes } }));
    },
    [resourceUpdater, writeback],
  );

  return (
    <div className="section-with-separator">
      <h2>Assessment</h2>
      {encounter?.assessment?.diagnosisCodes &&
        encounter?.assessment?.diagnosisCodes.map((diagnosis) => {
          return (
            <DetailsCardItem
              value={
                (
                  <>
                    <strong>
                      {diagnosis.code ? diagnosis.code.toUpperCase() : 'code not available'}
                    </strong>
                    &nbsp;-&nbsp;
                    {diagnosis.description}
                    &nbsp;
                    <i>{`(${diagnosis.system})`}</i>
                  </>
                ) as React.ReactNode
              }
              key={diagnosis.code}
            />
          );
        })}
      <SelectIcdToWriteback resourceType={'encounter'} />
      <EditableInput
        value={generalNotes}
        label="General notes"
        placeholder="Add notes here"
        handleOnSave={onSubmitGeneralNotes}
      />
    </div>
  );
};

export default EncounterAssessment;
